import axios from 'axios';

interface LocationEntry {
    utc: string;
    location: {
        type: string;
        coordinates: [number, number];
    };
}

export function useAppTracking() {
    interface LocationResponse {
        Entries: {
            Entry: Array<{
                utc: string;
                location: string; // JSON string
            }>;
        };
    }

    /**
     * Llama al servicio de tracking y retorna los datos parseados.
     */
    /**
     * Llama al servicio de tracking y retorna los datos parseados.
     * @param start_date Fecha de inicio (ISO 8601, opcional)
     * @param end_date Fecha de término (ISO 8601, opcional)
     */
    async function fetchLocationEntries(start_date?: string, end_date?: string): Promise<LocationEntry[]> {
        const url = 'http://localhost:5000/location';
        const params: Record<string, string> = {};
        if (start_date) params.start_date = start_date;
        if (end_date) params.end_date = end_date;
        const response = await axios.get<LocationResponse>(url, { params });
        return response.data.Entries.Entry.map(e => ({
            utc: e.utc,
            location: JSON.parse(e.location)
        }));
    }
    return {
        fetchLocationEntries
    }
}